import {PageRoute} from '@/constants';
import {TPageRouteType} from '@/types';
import {i18nKey} from '@/locales/i18n';

export enum THEME {
  LIGHT = 'light',
  DARK = 'dark',
}

export const OPACITY = {
  activate: '100%',
  deactivate: '60%',
};

export const SUB_MENU = {
  sub0: 'sub0',
  sub1: 'sub1',
  sub2: 'sub2',
  sub3: 'sub3',
  sub4: 'sub4',
  sub5: 'sub5',
  sub6: 'sub6',
  sub7: 'sub7',
  sub8: 'sub8',
  sub9: 'sub9',
  sub10: 'sub10',
  sub11: 'sub11',
  sub12: 'sub12',
  sub13: 'sub13',
};

export const ITEM_KEYS = {
  metadata: 'METADATA',
  usage: 'USAGE',
  invoice: 'INVOICE',
  department: 'DEPARTMENT',
  user: 'USER',
  processing_request: 'PROCESSING_REQUEST',
  document_processing_list: 'DOCUMENT_PROCESSING_LIST',
  document_template: 'DOCUMENT_TEMPLATE',
  config_billing: 'CONFIG_BILLING',
  request_work_flow: 'REQUEST_WORK_FLOW',
  work_flow: 'WORK_FLOWS',
  logging: 'LOGGING',
  docset_map: 'DOCSET_MAP',
  template_map: 'TEMPLATE_MAP',
};

export const ROUTER_MAP: Record<TPageRouteType, string> = {
  '/metadata': ITEM_KEYS.metadata,
  '/create-request': ITEM_KEYS.processing_request,
  '/document-processing-list': ITEM_KEYS.document_processing_list,
  '/document-template': ITEM_KEYS.document_template,
  '/usage': ITEM_KEYS.usage,
  '/invoice': ITEM_KEYS.invoice,
  '/department': ITEM_KEYS.department,
  '/user': ITEM_KEYS.user,
  '/config-billing': ITEM_KEYS.config_billing,
  '/request-workflow': ITEM_KEYS.request_work_flow,
  '/workFlow': ITEM_KEYS.work_flow,
  '/logging': ITEM_KEYS.logging,
  '/mbal/docset-map': ITEM_KEYS.docset_map,
  '/mbal/template-map': ITEM_KEYS.template_map,
};

export const ROUTER_SUB_MAP_ADMIN = {
  [SUB_MENU.sub0]: [PageRoute.ACCOUNT],
  [SUB_MENU.sub1]: [
    PageRoute.USAGE,
    PageRoute.INVOICE,
    PageRoute.INVOICE_DETAIL,
  ],
  [SUB_MENU.sub2]: [
    PageRoute.DEPARTMENTS,
    PageRoute.DEPARTMENTS_ADD,
    PageRoute.DEPARTMENTS_EDIT,
    PageRoute.DEPARTMENTS_DETAIL,
    PageRoute.USERS,
    PageRoute.USER_ADD,
    PageRoute.USER_EDIT,
  ],
  [SUB_MENU.sub3]: [
    PageRoute.DOCUMENT_TEMPLATE,
    PageRoute.DOCUMENT_TEMPLATE_ADD,
    PageRoute.DOCUMENT_TEMPLATE_EDIT,
    PageRoute.DOCUMENT_TEMPLATE_DETAIL,
  ],
  [SUB_MENU.sub4]: [PageRoute.CONFIG_BILLING],
  [SUB_MENU.sub12]: [PageRoute.LOGGING],
};

export const ROUTER_SUB_MAP_USER = {
  [SUB_MENU.sub0]: [PageRoute.ACCOUNT, PageRoute.REQUEST, PageRoute.METADATA],
  [SUB_MENU.sub5]: [PageRoute.PROCESSING_LIST],
  [SUB_MENU.sub6]: [
    PageRoute.DOCUMENT_TEMPLATE,
    PageRoute.DOCUMENT_TEMPLATE_ADD,
    PageRoute.DOCUMENT_TEMPLATE_EDIT,
    PageRoute.DOCUMENT_TEMPLATE_DETAIL,
  ],
  [SUB_MENU.sub7]: [PageRoute.SERVICE_HISTORY],
  [SUB_MENU.sub8]: [PageRoute.SUPPORT],
  [SUB_MENU.sub13]: [PageRoute.MBAL_DOCSET_MAP, PageRoute.MBAL_TEMPLATE_MAP],
};

export const ROUTER_FROM_ADMIN = {
  [PageRoute.ACCOUNT]: SUB_MENU.sub0,
  [PageRoute.USAGE]: SUB_MENU.sub1,
  [PageRoute.INVOICE]: SUB_MENU.sub1,
  [PageRoute.INVOICE_DETAIL]: SUB_MENU.sub1,
  [PageRoute.DEPARTMENTS]: SUB_MENU.sub2,
  [PageRoute.USERS]: SUB_MENU.sub2,
  [PageRoute.USER_ADD]: SUB_MENU.sub2,
  [PageRoute.USER_EDIT]: SUB_MENU.sub2,
  [PageRoute.DEPARTMENTS_ADD]: SUB_MENU.sub2,
  [PageRoute.DEPARTMENTS_EDIT]: SUB_MENU.sub2,
  [PageRoute.DOCUMENT_TEMPLATE]: SUB_MENU.sub3,
  [PageRoute.DOCUMENT_TEMPLATE_ADD]: SUB_MENU.sub3,
  [PageRoute.DOCUMENT_TEMPLATE_EDIT]: SUB_MENU.sub3,
  [PageRoute.DOCUMENT_TEMPLATE_DETAIL]: SUB_MENU.sub3,
  [PageRoute.CONFIG_BILLING]: SUB_MENU.sub4,
  [PageRoute.METADATA]: SUB_MENU.sub11,
  [PageRoute.REQUEST_WORKFLOW]: SUB_MENU.sub9,
  [PageRoute.WORKFLOW]: SUB_MENU.sub9,
  [PageRoute.PREVIEW_WORKFLOW]: SUB_MENU.sub9,
  [PageRoute.LOGGING]: SUB_MENU.sub12,
  [PageRoute.MBAL]: SUB_MENU.sub13,
  [PageRoute.MBAL_DOCSET_MAP]: SUB_MENU.sub13,
  [PageRoute.MBAL_TEMPLATE_MAP]: SUB_MENU.sub13,
};

export const ROUTER_FROM_USER = {
  [PageRoute.ACCOUNT]: SUB_MENU.sub0,
  [PageRoute.REQUEST]: SUB_MENU.sub0,
  [PageRoute.PROCESSING_LIST]: SUB_MENU.sub5,
  [PageRoute.PROCESSING_REVIEW]: SUB_MENU.sub5,
  [PageRoute.DOCUMENT_TEMPLATE]: SUB_MENU.sub6,
  [PageRoute.DOCUMENT_TEMPLATE_ADD]: SUB_MENU.sub6,
  [PageRoute.DOCUMENT_TEMPLATE_EDIT]: SUB_MENU.sub6,
  [PageRoute.DOCUMENT_TEMPLATE_DETAIL]: SUB_MENU.sub6,
  [PageRoute.SERVICE_HISTORY]: SUB_MENU.sub7,
  [PageRoute.SUPPORT]: SUB_MENU.sub8,
  [PageRoute.REQUEST_WORKFLOW]: SUB_MENU.sub9,
  [PageRoute.WORKFLOW]: SUB_MENU.sub9,
  [PageRoute.PREVIEW_WORKFLOW]: SUB_MENU.sub9,
  [PageRoute.METADATA]: SUB_MENU.sub10,
};

export const COLOR_ACCOUNT = {
  active: '#005676',
  deactivate: '#007CAA',
};

export enum LANGUAGE {
  EN = 'en',
  JP = 'jp',
}

export enum LANGUAGE_TYPE {
  EN = 'EN',
  JP = 'JP',
}

export const ITEM_INFO = [
  {
    key: 'ACCOUNT',
    label: () => i18nKey.header.titleAccount,
  },
  {
    key: 'LOG_OUT',
    label: () => i18nKey.header.titleLogOut,
  },
];

export const ITEM_LANGUAGE = [
  {
    key: 'en',
    label: () => i18nKey.header.en,
  },
  {
    key: 'jp',
    label: () => i18nKey.header.jp,
  },
];

export enum ITEM_KEY_INFO {
  ACCOUNT = 'ACCOUNT',
  LOG_OUT = 'LOG_OUT',
  EN = 'en',
  JP = 'jp',
}

export enum COLOR {
  blue200 = '##1570EF',
  green200 = '#EFF8FF',
  color_000 = '#FFFFFF',
  bgLight = '#5348EC',
  bgHeader = '#e8e7ec',
  clIconToolbar = '#6B6888',
  btnText100_dark = '#48505E',
  color_asterisk = '#F04438',
  color_text_table = '#000000E0',
}
